export const menu = [
    {
        headTitle1: 'menu.section_main',
        type: 'headtitle',
    },
    {
        path: '/dashboard',
        id: 'dashboard',
        title: 'menu.dashboard',
        icon: 'home',
        type: 'link',
        level: 1,
        isPinned: false,
        active: false,
        bookmark: true,
    },
    {
        headTitle1: 'menu.section_management',
        type: 'headtitle',
    },
    {
        title: 'menu.bots',
        id: 'bots',
        icon: 'chat',
        type: 'sub',
        level: 1,
        active: false,
        isPinned: false,
        children: [
            { path: '/bots', title: 'menu.all_bots', type: 'link' },
            { path: '/bots/new', title: 'menu.create_bot', type: 'link' },
        ],
    },
    {
        title: 'menu.campaigns',
        id: 'campaigns',
        icon: 'email',
        type: 'sub',
        level: 1,
        active: false,
        isPinned: false,
        children: [
            { path: '/campaigns', title: 'menu.all_campaigns', type: 'link' },
            { path: '/campaigns/new', title: 'menu.create_campaign', type: 'link' },
        ],
    },
    {
        path: '/templates',
        id: 'templates',
        title: 'menu.templates',
        icon: 'file',
        type: 'link',
        level: 1,
        isPinned: false,
        active: false,
    },
    {
        path: '/unanswered',
        id: 'unanswered',
        title: 'menu.unanswered',
        icon: 'help-circle',
        type: 'link',
        level: 1,
        isPinned: false,
        active: false,
    },
    {
        headTitle1: 'menu.section_integrations',
        type: 'headtitle',
    },
    {
        path: '/integrations',
        id: 'integrations',
        title: 'menu.integrations',
        icon: 'api',
        type: 'link',
        level: 1,
        isPinned: false,
        active: false,
    },
    {
        headTitle1: 'menu.section_analytics',
        type: 'headtitle',
    },
    {
        path: '/analytics',
        id: 'analytics',
        title: 'menu.analytics',
        icon: 'charts',
        type: 'link',
        level: 1,
        isPinned: false,
        active: false,
    },
    {
        headTitle1: 'menu.section_account',
        type: 'headtitle',
    },
    {
        path: '/settings',
        id: 'settings',
        title: 'menu.settings',
        icon: 'widget',
        type: 'link',
        level: 1,
        isPinned: false,
        active: false,
    },
];
